<template>
  <div class="wrapper">
    <div class="centerWapper">
      <div class="box_bkg">
        <img
          class="box_close"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/gifts_close.png"
          alt
          @click="close"
        />
        <div class="mainBox">
          <div>
            <!-- 会员中心 -->
            <template v-if="giftMemberList">
              <GoodsCard member="true" v-for="(item, index) in giftMemberList" :key="index" :goodsInfo="item" />
            </template>
            <template v-if="giftMaterialList">
              <GoodsCard v-for="(item, index) in giftMaterialList" :key="index" :goodsInfo="item" />
            </template>
            <template v-if="wholeGiftlist">
              <NewCouponCard
                isModal
                v-for="item in wholeGiftlist"
                :key="item.id"
                :goodsInfo="item"
                :source="source"
              />
            </template>
          </div>
        </div>
      </div>
      <div class="btn_close" @click="close">立即领取</div>
      <!-- <div class="bottomAccept" @click="close"></div> -->
    </div>
  </div>
</template>

<script>
// import CouponCard from '@/pages/payment/couponPop/couponCard.vue';
import GoodsCard from '@/pages/payment/couponPop/goodsCard.vue';
import NewCouponCard from '@/pages/payment/couponPop/newCouponCard.vue';

export default {
  props: {
    // 赠券列表
    wholeGiftlist: {
      type: Array,
      default: () => null,
    },
    // 赠实物列表
    giftMaterialList: {
      type: Array,
      default: () => null,
    },
    giftMemberList: {
      type: Array,
      default: () => null,
    },
    isOrderAddres: {
      type: Boolean,
    },
  },

  components: {
    // CouponCard,
    GoodsCard,
    NewCouponCard,
  },
  computed: {
    showBgItem() {
      // 1 有实物 2 没有
      // let bgType = 1;
      return this.giftMaterialList ? 1 : 2;
      // 弹窗使用的背景图
    },
  },
  data() {
    return {
      source: 1,
    };
  },
  mounted() {},

  destroyed() {},
  methods: {
    close() {
      if (this.showBgItem === 1 && !this.isOrderAddres) {
        // 有实物去写地址页面
        this.$router.push({
          path: '/personalCenter/address',
          query: {
            orderNo: this.$route.query.orderNo,
            giftPageAddress: true,
          },
        });
      } else {
        this.$emit('closeOverlay');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .centerWapper {
    // background-size: 100% 100%;
    position: relative;
    width: 634px;
    height: 1062px;

    .box_bkg {
      width: 634px;
      height: 880px;
      overflow: hidden;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/gifts_succ.png')
        no-repeat;
      background-size: 100% 100%;
    }

    .btn_close {
      width: 326px;
      height: 87px;
      margin: 22px auto 0;
      color: #fff;
      font-weight: bold;
      font-size: 33px;
      font-family: SourceHanSansCN, sans-serif;
      line-height: 87px;
      text-align: center;
      text-shadow: 0 4px 11px rgba(183, 40, 40, 0.32);
      background: linear-gradient(130deg, #fdbe3c 0%, #ff3f17 100%);
      border-radius: 43px;
    }
    .box_close {
      float: right;
      width: 54px;
      height: 54px;
    }

    .mainBox {
      width: 549px;
      height: 525px;
      margin: 286px auto 0;
      overflow-y: auto;
    }
    .bottomAccept {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      width: 700px;
      height: 224px;
    }
    .couponClose {
      position: absolute;
      top: 90px;
      right: 28px;
      width: 32px;
      height: 32px;
    }
  }
  .couponBg {
    background: url(../../../assets/img/payment/popBg.png) no-repeat center;
    background-size: 100% 100%;
    .mainBox {
      margin: 240px auto 0 auto;
      padding-bottom: 50px;
    }
    .bottomAccept {
      background: url(../../../assets/img/payment/botAccept.png) no-repeat center;
      background-size: 100% 100%;
    }
  }
  .physicalBg {
    background: url(../../../assets/img/payment/phyBg.png) no-repeat center;
    background-size: 100% 100%;
    .mainBox {
      margin: 265px auto 0 auto;
      padding-bottom: 72px;
    }
    .bottomAccept {
      background: url(../../../assets/img/payment/phyAccept.png) no-repeat center;
      background-size: 100% 100%;
    }
  }
}
</style>
